import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Mail, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { AppleSignInButton } from "@/components/AppleSignInButton";

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const referralCode = params.get("ref") || params.get("code") || params.get("invite") || "";
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <form className="auth-card fade-up" onSubmit={onLogin}>
        <div style={{ display: "flex", justifyContent: "center" }}><Logo height={84} /></div>
        <p className="ss-muted" style={{ textAlign: "center", marginTop: 8 }}>Connecting Muslim sellers to buyers, live.</p>

        <div style={{ marginTop: 26, display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="ss-field">
            <Mail size={18} className="ss-muted" />
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="ss-field">
            <Lock size={18} className="ss-muted" />
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <div style={{ color: "var(--red)", fontWeight: 600, fontSize: 14 }} data-testid="login-error">{error}</div>}
          <button className="ss-btn ss-btn-primary ss-btn-block" disabled={loading} data-testid="login-submit-button">
            {loading ? "Logging in…" : "Log In"}
          </button>
        </div>

        <GoogleSignInButton redirectTo="/" referralCode={referralCode} />
        <AppleSignInButton redirectTo="/" referralCode={referralCode} />

        <div style={{ textAlign: "center", marginTop: 14 }}>
          <span style={{ color: "var(--brand)", fontWeight: 700, cursor: "pointer", fontSize: 14 }} onClick={() => navigate("/forgot-password")} data-testid="forgot-password-link">
            Forgot password?
          </span>
        </div>

        <div style={{ textAlign: "center", marginTop: 16 }} className="ss-muted">
          New here?{" "}
          <span style={{ color: "var(--brand)", fontWeight: 800, cursor: "pointer" }} onClick={() => navigate("/signup")} data-testid="go-signup-button">
            Create an account
          </span>
        </div>
      </form>
    </div>
  );
}
